<template>
    <div class="flex row vertical-center">
        <div class="panel-nav-list-container">
            <ul class="panel-nav-list">
                <li class="panel-nav-item cb-item" v-on:click="$emit('company')">COMPANY BREAKDOWN</li>
                <li class="panel-nav-item to-item" v-on:click="$emit('offer')">THE OFFERING</li>
                <li class="panel-nav-item ta-item" v-on:click="$emit('app')">THE APPLICATION</li>
                <li class="panel-nav-item ot-item" @click="team_route()">OUR TEAM</li>
            </ul>
        </div>
        <div class="panel-nav-bar"></div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        },
        methods: {
            team_route: function(e) {
                this.$router.push({'name': 'Team'})
            }
        }
    }
</script>

<style scoped>
    .panel-nav-list-container {
        display: inline-block;
    }

    .panel-nav-list {
        margin: 0px;
        padding: 0px;
    }

    .panel-nav-item {
        cursor: pointer;
        margin: 45px 15px 40px 0;
        text-align: right;
        color: #888888;
        font-family: Oswald;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 1.44px;
        list-style-type: none;
    }

    .panel-nav-item:hover {
        color: rgb(218, 174, 62);
    }

    .panel-nav-bar {
        height: 225px;
        width: 2px;
        transform: scaleX(-1);
        background: linear-gradient(180deg, #93692A 0%, #EDD767 100%);
    }
</style>



// WEBPACK FOOTER //
// src/components/home/Panel_Nav.vue